import { Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const style = makeStyles({
  PageTitle: {
    color: "#FFFFFF",
    fontStyle: "normal",
    fontFamily: "poppins, sans-serif",
    fontWeight: 700,
    fontSize: 72,
  },
});

const PageTitle = () => {
  const classes = style();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          align={"center"}
          gutterBottom={true}
          className={classes.PageTitle}
        >
          YAO LABS
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PageTitle;
